import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=70fd39cd&scoped=true"
import script from "./AreaEdit.vue?vue&type=script&lang=js"
export * from "./AreaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd39cd",
  null
  
)

export default component.exports